<template>
    <div class="kgk-register-form">
        <h1>Registrierung</h1>

        <p v-if="inviteId" class="kgk-form-row">
            <i class="fas fa-info-circle"></i>
            Du wurdest zu einem Team eingeladen. Nach Abschluss der Registrierung wirst du automatisch Mitglied.
        </p>

        <h6>Der <span class="kgk-required-label"></span> markiert erforderliche Felder</h6>

        <form @submit.prevent="performRegistration">
            <div class="kgk-form-row register-input-row-0 kgk-required-label">
                E-Mail
                <div class="kgk-input-group">
                    <input type="email" required v-model="form.email" name="email" tabindex="1">
                </div>
            </div>
            <div class="kgk-form-row register-input-row-1 kgk-required-label">
                Passwort
                <div class="kgk-input-group">
                    <input type="password" required v-model="form.password" name="password" tabindex="3">
                </div>
                <div v-if="showValidationErrors && !passwordLengthValidation" class="kgk-form-validation-error-inline">Passwort muss mindestens 8 Zeichen haben.</div>
            </div>
            <div class="kgk-form-row register-input-row-2 kgk-required-label">
                Passwort bestätigen
                <div class="kgk-input-group">
                    <input type="password" required v-model="passwordConfirm" name="password-confirmation" tabindex="4">
                </div>
                <div v-if="!passwordEqualityValidation" class="kgk-form-validation-error-inline">Passwörter stimmen nicht überein</div>
            </div>

            <div class="kgk-form-row register-input-row-3 kgk-required-label">
                Benutzername
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.username" name="username" tabindex="2">
                </div>
                <div v-if="!usernameValidation" class="kgk-form-validation-error-inline">Benutzername enthält ungültige Zeichen – erlaubt sind A-Z, a-z, 0-9, -, _, @, !, ., Umlaute (KEINE Leerzeichen).</div>
                <div v-if="!usernameLengthValidation" class="kgk-form-validation-error-inline">Benutzername muss zwischen 5 und 16 Zeichen lang sein.</div>
            </div>

            <div class="kgk-form-row register-input-row-4 kgk-required-label">
                Vorname
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.prename" name="prename" tabindex="5">
                </div>
            </div>
            <div class="kgk-form-row register-input-row-5 kgk-required-label">
                Nachname
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.surname" name="surname" tabindex="6">
                </div>
            </div>

            <div class="kgk-form-row register-input-row-5">
                Firma

                <div v-if="form.companyData" class="kgk-input-group">
                    <input type="text" disabled :value="form.companyData.name" name="companyDataName" style="padding-right: 48px">
                    <!--<div class="kgk-input-group-append"><a href="#" @click.prevent="editCompany"><i class="fas fa-pencil fa-fw"></i></a></div>-->
                    <div class="kgk-input-group-append"><a href="#" style="color:#dd0000" @click.prevent="clearCompany"  v-tooltip="'Firma entfernen'"><i class="fas fa-trash fa-fw"></i></a></div>
                </div>
                <div v-if="!form.companyData" style="margin-top:8px;">
                    <SelectCompany :current-company="form.companyData" @selected="onCompanySelected" />
                </div>
                <!--<div class="kgk-input-group">
                    <input type="text" v-model="form.company" name="company">
                </div>-->
            </div>

            <!--div class="kgk-form-row register-input-row-6 kgk-required-label">
                Geburtsdatum
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.birthday" placeholder="dd.mm.yyyy" name="birthday">
                </div>
                <div v-if="showValidationErrors && !birthdayFormatValidation" class="kgk-form-validation-error-inline">Ungültiges Datum</div>
                <datetime
                        type="date"
                        format="cccc, dd.LL.yy"
                        value-zone="UTC+2"
                        zone="UTC+2"
                        v-model="form.birthday"
                        inputClass="form-control text-center"
                        auto
                        :phrases="{cancel: 'Abbrechen', ok: 'Übernehmen'}">
                </datetime>
            </div>-->

            <!--<div class="kgk-form-row register-input-row-7">
                Straße & Hausnummer
                <div class="kgk-input-group">
                    <input type="text" v-model="form.street" name="street">
                    <input type="text" v-model="form.streetnumber" style="width:20%;" name="streetnumber">
                </div>
            </div>-->
            <div class="kgk-form-row register-input-row-7 kgk-required-label">
                PLZ
                <div class="kgk-input-group">
                    <input type="number" required v-model="form.zip" style="width:20%;" name="zip" tabindex="7">
                </div>
            </div>

            <div class="kgk-form-row register-input-row-8 kgk-required-label">
                Stadt
                <div class="kgk-input-group">
                    <input type="text" required v-model="form.city" name="city" tabindex="8">
                </div>
            </div>

            <div class="kgk-form-row kgk-form-row--wide register-input-row-9 kgk-required-label" style="max-width: none;">
                <label>
                    <input type="checkbox" v-model="form.consent_campaign">
                    Ich habe die Datenschutzerklärung zur Kenntnis genommen und stimme der Verwendung meiner Daten gemäß Datenschutzerklärung zu.
                </label>
                <div v-if="showValidationErrors && !consentCampaignValidation" class="kgk-form-validation-error-inline">Sie müssen der Datenverarbeitung zustimmen.</div>
            </div>

            <div class="kgk-form-row kgk-form-row--wide register-input-row-10" style="max-width: none;">
                <label>
                    <input type="checkbox" v-model="form.consent_afterwards">
                    Ich stimme zu, zukünftig per E-Mail über Neuigkeiten und Aktionen der Krebsgesellschaft NRW informiert zu werden.
                </label>
            </div>

            <div class="kgk-form-row kgk-form-row--wide kgk-required-label" id="verify-age-jump">
                <label>
                    <input type="checkbox" v-model="form.verify_age">
                    Ich bestätige, dass ich zum Zeitpunkt der Registrierung mindestens 16 Jahre alt bin.
                </label>
            </div>

            <div class="kgk-form-row register-input-row-11">
                <button type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span class="button-text">Registrieren</span>
                </button>
            </div>
        </form>

        <div v-if="error">
            <div class="kgk-form-row">Fehler: {{error}}</div>
        </div>
    </div>
</template>

<script>
    import registration from '../../api/registration';
    import SelectCompany from '@/components/login/SelectCompany';
    import router from '../../router';
    //import { Datetime } from 'vue-datetime';

    const dateRegex = /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/;
    const usernameRegex = /[-_@!.a-zA-Z0-9äÄöÖüÜß]/g;

    export default {
        name: 'RegisterForm',
        components: {
            //datetime: Datetime
            SelectCompany,
        },
        props: {
            inviteId: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                loading: false,
                error: false,
                form: {
                    email: '',
                    password: '',
                    username: '',
                    prename: '',
                    surname: '',
                    company: '',
                    companyData: null,
                    birthday: '',
                    street: '',
                    streetnumber: '',
                    zip: '',
                    city: '',
                    consent_campaign: false,
                    consent_afterwards: false,
                    verify_age: false
                },
                showValidationErrors: false,
                passwordConfirm: ''
            }
        },
        computed: {
            usernameValidation() {
                if( this.form.username.length == 0 ) {
                    return true;
                }

                return this.form.username.replace(usernameRegex, '').trim().length === 0;
            },
            usernameLengthValidation() {
                const length = this.form.username.trim().length;
                return length == 0 || (length >= 5 && length <= 16);
            },
            birthdayFormatValidation() {
                if( this.form.birthday.trim().length == 0 ) {
                    return true;
                }

                return dateRegex.test(this.form.birthday);
            },
            consentCampaignValidation() {
                return !!this.form.consent_campaign;
            },
            passwordLengthValidation() {
                return this.form.password.length >= 8;
            },
            passwordEqualityValidation() {
                if( this.form.password.length == 0 || this.passwordConfirm.length == 0 ) {
                    return true;
                }

                return this.form.password === this.passwordConfirm;
            },
            verifyAgeValidation() {
                return !!this.form.verify_age;
            },
        },
        methods: {
            /*editCompany() {

            },*/
            clearCompany() {
                this.form.companyData = null;
            },
            onCompanySelected(companyData) {
                console.log('onCompanySelected', JSON.stringify(companyData));
                this.form.companyData = companyData;
            },
            performRegistration: function() {
                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                if( !this.usernameValidation
                    || !this.usernameLengthValidation
                    || !this.birthdayFormatValidation
                    || !this.consentCampaignValidation
                    || !this.passwordLengthValidation
                    || !this.passwordEqualityValidation
                    || !this.verifyAgeValidation ) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigieren Sie Ihre Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                registration.register(
                    this,
                    { ...this.form, invite: this.inviteId },
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Registrierung abgeschlossen',
                            text: this.inviteId
                                ? 'Deine Registrierung war erfolgreich und du bist dem Team beigetreten. Zum Aktivieren deines Accounts musst du dem Freischaltlink folgen, den wir dir per Mail zugeschickt haben.'
                                : 'Deine Registrierung war erfolgreich. Zum Aktivieren deines Accounts musst du dem Freischaltlink folgen, den wir dir per Mail zugeschickt haben.',
                            duration: 8000,
                        });

                        router.push('/login');
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => this.loading = false
                );
            },
        },
        mounted() {
            //if( this.mode == 'edit' ) {

            //}
        },
    }
</script>

<style lang="scss">
.kgk-required-label::before{
    content:'*';
    color:#f00;
}

</style>